/** Validate an EndTurn action (rule.md §5 — may pass with AP unspent). */
import type { EndTurnAction } from "../types/action";
import type { ValidationResult } from "../types/common";
import type { AugmentedWarState } from "../types/game-state";
import { validateTurn } from "./shared";

export function validateEndTurn(
  state: AugmentedWarState,
  action: EndTurnAction,
): ValidationResult {
  return validateTurn(state, action.playerId);
}
